import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import getBreadcrumbsForPage from 'commons/getBreadcrumbsForPage';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
function addHomeAndProductName(breadCrumbItems, productName) {
  const result = breadCrumbItems.concat({
    label: productName,
    link: ''
  });
  if (result[0].label === 'Home') {
    return result;
  }
  return [{
    label: 'Home',
    link: '/shop'
  }].concat(result);
}
const usePDPBreadcrumbs = () => {
  const $ = _c(12);
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const params = useParams();
  const {
    loading,
    error,
    data: productDetails
  } = usePDPBasicDetails();
  params?.category;
  productDetails?.name;
  let t0;
  bb0: {
    if (productDetails?.name) {
      const productName = productDetails?.name;
      const categoryName = params?.category;
      if (pdpIsModularBYOProduct) {
        let t1;
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            label: "Home",
            link: "/"
          };
          t2 = {
            label: "Modular sofas",
            link: "/modular-sofas/"
          };
          $[0] = t1;
          $[1] = t2;
        } else {
          t1 = $[0];
          t2 = $[1];
        }
        let t3;
        if ($[2] !== productName) {
          t3 = [t1, t2, {
            label: productName,
            link: ""
          }];
          $[2] = productName;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        const productBreadCrumbs = t3;
        t0 = productBreadCrumbs;
        break bb0;
      }
      if (categoryName) {
        let t1;
        if ($[4] !== categoryName || $[5] !== productName) {
          const allBreadCrumbs = getBreadcrumbsForPage("pdp");
          t1 = allBreadCrumbs?.[categoryName] && allBreadCrumbs?.[allBreadCrumbs[categoryName]] ? addHomeAndProductName(allBreadCrumbs[allBreadCrumbs[categoryName]], productName) : [{
            label: "Home",
            link: "/"
          }, {
            label: productName,
            link: ""
          }];
          $[4] = categoryName;
          $[5] = productName;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        const productBreadCrumbs_0 = t1;
        t0 = productBreadCrumbs_0;
        break bb0;
      }
    }
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [];
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    t0 = t1;
  }
  const breadCrumbs = t0;
  let t1;
  if ($[8] !== breadCrumbs || $[9] !== error || $[10] !== loading) {
    t1 = {
      loading,
      error,
      data: breadCrumbs
    };
    $[8] = breadCrumbs;
    $[9] = error;
    $[10] = loading;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
};
export default usePDPBreadcrumbs;